import React, { useLayoutEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { Link } from '../Link/Link.js';
const TRUNCATE_SIZE_MAPPER = {
    sm: 'max-h-[6rem]',
    md: 'max-h-[27rem]',
    lg: 'max-h-[50rem]',
};
export const Truncate = ({ children, size = 'sm', expandable = true, seeMoreText, seeLessText, scrollOffset = '0', gradientTo = 'to-surface', }) => {
    var _a;
    const [isTruncated, setIsTruncated] = useState(false);
    const [showingMore, setShowingMore] = useState(false);
    const parentRef = useRef(null);
    const childRef = useRef(null);
    const scrollRef = useRef(null);
    const scrollParentIntoView = () => {
        const scrollElement = scrollRef.current;
        scrollElement.scrollIntoView({
            behavior: 'smooth',
        });
    };
    useLayoutEffect(() => {
        const childElement = childRef.current;
        const resizeObserver = new ResizeObserver(entries => {
            const parentElement = parentRef.current;
            const parentHeight = parentElement.getBoundingClientRect().height;
            const childHeight = entries[0].contentRect.height;
            if (childHeight > parentHeight) {
                setIsTruncated(true);
            }
        });
        resizeObserver.observe(childElement);
        return () => {
            resizeObserver.unobserve(childElement);
        };
    }, []);
    useLayoutEffect(() => {
        const parentElement = parentRef.current;
        const resetScroll = () => {
            const { scrollTop } = parentElement;
            if (scrollTop !== 0) {
                parentElement.scrollTo(0, 0);
            }
        };
        parentElement.addEventListener('scroll', resetScroll);
        return () => {
            parentElement.removeEventListener('scroll', resetScroll);
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: parentRef, className: clsx('overflow-hidden relative', !showingMore &&
                ((_a = TRUNCATE_SIZE_MAPPER === null || TRUNCATE_SIZE_MAPPER === void 0 ? void 0 : TRUNCATE_SIZE_MAPPER[size]) !== null && _a !== void 0 ? _a : TRUNCATE_SIZE_MAPPER.sm)) },
            React.createElement("div", { ref: scrollRef, className: "absolute", style: { top: scrollOffset } }),
            React.createElement("div", { ref: childRef }, children),
            isTruncated && !showingMore && (React.createElement("div", { className: clsx('absolute left-0 bottom-0 w-full h-3 bg-gradient-to-b from-[rgba(255,255,255,0)]', gradientTo) }))),
        isTruncated && expandable && (React.createElement("div", { className: "mt-2" }, showingMore ? (React.createElement(Link, { as: "button", onClick: () => {
                setShowingMore(false);
                scrollParentIntoView();
            } }, seeLessText)) : (React.createElement(Link, { as: "button", onClick: () => setShowingMore(true) }, seeMoreText))))));
};
//# sourceMappingURL=Truncate.js.map